var _ = require("../../../uam/module.js")(module.exports, {
  namespace: "docs.markdown.page",
  title: "Docs Markdown Page",
  description: "Renders docs navigation, markdown content, and search UI for generated docs pages.",
  supportServer: true,
  fields: {
    current: { title: "Current Route", type: "string", required: true, description: "Current docs route key." },
    pages: { title: "Pages", type: "list", required: true, description: "Search and metadata list." },
    navTree: { title: "Navigation Tree", type: "object", required: true, description: "Folder tree navigation object." },
    html: { title: "HTML", type: "string", required: true, description: "Rendered markdown html." },
    headings: { title: "Headings", type: "list", required: false, description: "Page heading list for right toc." },
    appName: { title: "App Name", type: "string", required: false, description: "App name for alt text." },
    logoUrl: { title: "Logo URL", type: "string", required: false, description: "Logo URL." }
  }
});

var fs = require("fs");
var path = require("path");

function escapeHtml(text) {
  return (text || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function safeJsonForScript(value) {
  return JSON.stringify(value || {})
    .replace(/</g, "\\u003C")
    .replace(/>/g, "\\u003E")
    .replace(/&/g, "\\u0026")
    .replace(/\u2028/g, "\\u2028")
    .replace(/\u2029/g, "\\u2029");
}

var docsCssCache = "";
var docsClientJsCache = "";

function readAsset(relativePath) {
  try {
    return fs.readFileSync(path.resolve(__dirname, "../public/" + relativePath), "utf8");
  } catch (error) {
    console.warn("docs.markdown.page: unable to load plugin asset for inline fallback.", {
      file: relativePath,
      error: error
    });
    return "";
  }
}

async function render(options) {
  var holder = document.createElement("section");
  holder.className = "docs-plugin-shell";

  var appName = options.appName || "Universe App";
  var logoUrl = options.logoUrl || "/logo.svg";

  var toc = Array.isArray(options.headings) ? options.headings : [];
  var tocHtml = "";
  for (var i = 0; i < toc.length; i++) {
    tocHtml += '<a class="docs-toc-level-' + toc[i].level + '" href="#' + escapeHtml(toc[i].id) + '">' + escapeHtml(toc[i].text) + "</a>";
  }

  holder.innerHTML = ''
    + '<header class="docs-top">'
    + '<div class="docs-top-left">'
    + '<a class="btn btn-sm btn-underline-primary d-inline-flex align-items-center gap-2" href="/" title="Home">'
    + '<i class="bi bi-chevron-left" aria-hidden="true"></i>'
    + '<img class="docs-home-logo" src="' + escapeHtml(logoUrl) + '" alt="' + escapeHtml(appName) + ' logo" />'
    + '</a>'
    + '<a class="btn btn-sm btn-underline-secondary d-inline-flex align-items-center gap-2" href="/p/docs/index" title="Docs Index">'
    + '<i class="bi bi-house" aria-hidden="true"></i>'
    + '</a>'
    + '</div>'
    + '<div class="docs-top-right">'
    + '<button class="btn btn-sm btn-underline-secondary docs-mobile-menu-toggle" type="button" data-docs-toggle="allnav" title="Toggle All Navigation" aria-label="Toggle All Navigation" aria-expanded="false"><i class="bi bi-list"></i></button>'
    + '<button id="docs-fullscreen-toggle" class="btn btn-sm btn-underline-secondary d-inline-flex align-items-center gap-2" type="button" title="Toggle Focus Mode" aria-label="Toggle Focus Mode" aria-pressed="false"><i class="bi bi-fullscreen"></i></button>'
    + '<input id="docs-search-input" type="search" placeholder="Search docs" autocomplete="off" />'
    + '</div>'
    + '</header>'
    + '<section class="docs-mobile-nav">'
    + '<div class="docs-mobile-nav-backdrop" id="docs-mobile-nav-backdrop" data-collapsed="true"></div>'
    + '<div class="docs-mobile-nav-panel" id="docs-mobile-nav-panel" data-collapsed="true">'
    + '<div class="docs-mobile-nav-header">'
    + '<h2 class="docs-mobile-nav-title">All Docs Navigation</h2>'
    + '<button class="btn btn-sm btn-underline-secondary" type="button" data-docs-close="allnav" title="Close Navigation" aria-label="Close Navigation"><i class="bi bi-x-lg"></i></button>'
    + '</div>'
    + '<nav id="docs-tree-mobile"></nav>'
    + '<h2 class="docs-mobile-nav-title docs-mobile-nav-title-secondary">On This Page</h2>'
    + '<nav id="docs-toc-mobile">' + tocHtml + '</nav>'
    + '</div>'
    + '</section>'
    + '<main class="docs-layout">'
    + '<aside class="docs-sidebar" data-collapsed="false">'
    + '<nav id="docs-tree"></nav>'
    + '</aside>'
    + '<section class="docs-content"><article class="docs-article">' + (options.html || "") + '</article></section>'
    + '<aside class="docs-toc" data-collapsed="false">'
    + '<nav id="docs-toc">' + tocHtml + '</nav>'
    + '</aside>'
    + '</main>'
    + '<section id="docs-search-results" class="docs-search-results" hidden></section>';

  var payloadScript = document.createElement("script");
  payloadScript.type = "application/json";
  payloadScript.id = "docs-manifest-json";
  payloadScript.textContent = safeJsonForScript({
    autogenerated: true,
    current: options.current || "index",
    defaultPage: "index",
    pages: options.pages || [],
    navTree: options.navTree || { name: "docs", type: "folder", children: [] }
  });
  holder.appendChild(payloadScript);

  if (!(docsCssCache)) {
    docsCssCache = readAsset("docs.css");
  }
  if (docsCssCache) {
    var inlineCss = document.createElement("style");
    inlineCss.id = "docs-plugin-inline-css";
    inlineCss.textContent = docsCssCache;
    holder.appendChild(inlineCss);
  }

  if (!(docsClientJsCache)) {
    docsClientJsCache = readAsset("docs.client.js");
  }
  if (docsClientJsCache) {
    var inlineClientScript = document.createElement("script");
    inlineClientScript.id = "docs-plugin-inline-client";
    inlineClientScript.textContent = docsClientJsCache;
    holder.appendChild(inlineClientScript);
  } else {
    var clientScript = document.createElement("script");
    clientScript.src = "/plugins/docs/docs.client.js";
    clientScript.defer = true;
    holder.appendChild(clientScript);
  }

  return holder;
}
module.exports.render = render;
